import React from "react";
import { Trans } from "react-i18next";
import styled from "styled-components";

const MessageRoot = styled.span`
    display: block;
    margin: 0;
`;

const LearnMoreLink = (props: { children?: React.ReactNode }) => (
    <a
        href="https://support.beautiful.ai/hc/en-us/articles/360000771231-How-can-I-collaborate-with-someone-"
        target="_blank"
        rel="noopener noreferrer"
    >
        {props.children}
    </a>
);
export function PresentationLibraryShareNoticeMessage() {
    return (
        <MessageRoot data-testid="PresentationLibraryShareNoticeMessage-root">
            <Trans
                i18nKey="Maybe you should share one of yours? <br/><gdriveLink>Learn more</gdriveLink> about sharing and collaboration."
                components={{
                    br: <br />,
                    gdriveLink: <LearnMoreLink />
                }}
            />
        </MessageRoot>
    );
}
